
import { Component } from '@angular/core';
import { AppointmentTime, Site } from './site';
import { AppointmentType } from '../appointment/appointment-type';
import { ManagementService } from '../management.service';
import { FormsModule } from '@angular/forms';
import { AppointmentService } from '../appointment/appointment.service';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { provideNativeDateAdapter } from '@angular/material/core';
// import { Alert } from 'bootstrap';

@Component({
    selector: 'app-site',
    imports: [
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule
],
    providers: [
        provideNativeDateAdapter(),
    ],
    templateUrl: './site.component.html',
    styleUrl: './site.component.scss'
})
export class SiteComponent {
  selectedSite: Site | null = null
  siteInformation: Site | null = null
  sites: Site[] = []
  savingAppointmentTime = false
  error: String | null = null
  addAppointmentTimeButtonClicked = false
  appointmentTypes: AppointmentType[] = []
  appointmentTimes: {[key: string]: AppointmentTime[]} = {}
  siteInformationAppointmentTimes: AppointmentTime[] = []
  siteDescriptiveTimes: string[] = []
  addAppointmentTimeScheduledTimeOptions: Times[] = this.generateTimes(30)
  defaultAddAppointmentTimeInformation: AddAppointmentTimeInformation = {
    // appointmentTimeId: 0,
    appointmentType: '',
    numberOfAppointments: 0,
    // numberOfAppointmentsAlreadyScheduled: 0,
    scheduledDateString: '',
    scheduledTimeString: '',
    is_hidden: false,
    // editing: false,
    // selectedDate: '',
  }
  addAppointmentTimeInformation = this.defaultAddAppointmentTimeInformation
  selectedDate: Date | null = null

  dateFilter(d: Date | null): boolean {
    return true
    // const date = (d || new Date());
    // const year = date.getFullYear()
    // const month = (date.getMonth() + 1 + "").padStart(2,'0')
    // const day = (date.getDate() + "").padStart(2,'0')
    // const calendarDay = `${year}-${month}-${day}`
    // // Prevent Saturday and Sunday from being selected.
    // return this.validDates.includes(calendarDay)
  };
  
  constructor(private managementService: ManagementService, private appointmentService: AppointmentService) { }

  ngOnInit() {
    this.loadSites()
    this.appointmentService.getAppointmentTypes().subscribe((result) => {
      this.appointmentTypes = result
    })
  }

  generateTimes(interval: number, startTime = 0, endTime = 24*60, endTimeInclusive = false): Times[] {
    const times = [];
    let time = startTime; // Start at 00:00 (12:00 AM)
    const periods = ['AM', 'PM'];

    for (let i = 0; endTimeInclusive ? (time <= endTime) : (time < endTime); i++) {
      const hour = Math.floor(time / 60); // Get hours of day in 0-23 format
      const minute = (time % 60); // Get minutes of the hour in 0-59 format
      const hourString = ((hour === 12 || hour === 0) ? 12 : hour % 12); // Transform to 1-12 format
      const minuteString = ('0' + minute).slice(-2); // Append a 0 to minute if necessary
      const periodString = periods[Math.floor(hour / 12)];

      times[i] = { 
        timeString: `${hourString}:${minuteString} ${periodString}`,
        time: time
      };
      time = time + interval;
    }

    return times;
  }

  loadSites() {
    this.managementService.getSites()
    .subscribe((result) => {
      this.sites = result;
    });
  }

  editAppointmentTimeSaveButtonHandler(appointmentTime: AppointmentTime){
    const appointmentTimeId = appointmentTime.appointmentTimeId;
    const newNumberOfAppointments = appointmentTime.numberOfAppointments; // fixme: This said newNumberOfAppointments before, so this can't be right
    this.managementService.updateAppointmentTime(appointmentTimeId, newNumberOfAppointments).subscribe((result) => {
      appointmentTime.numberOfAppointments = newNumberOfAppointments;
      appointmentTime.editing = false;
    });
  }

  editAppointmentTimesEditButtonHandler(appointmentTime: AppointmentTime)  {
    appointmentTime.editing = true
    // this.appointmentTimes[appointmentTime.scheduledDateString].push({ 
    //   appointmentTimeId: appointmentTime.appointmentTimeId, 
    //   appointmentType: '',
    //   scheduledDateString: appointmentTime.scheduledDateString,
    //   scheduledTimeString: '',
    //   editing: true, 
    //   numberOfAppointments: appointmentTime.numberOfAppointments,
    //   numberOfAppointmentsAlreadyScheduled: appointmentTime.numberOfAppointmentsAlreadyScheduled,
    // });
  }

  dateChanged(newDate: Date) {
    const year = newDate.getFullYear()
    const month = (newDate.getMonth() + 1 + "").padStart(2,'0')
    const day = (newDate.getDate() + "").padStart(2,'0')
    this.addAppointmentTimeInformation.scheduledDateString = `${year}-${month}-${day}`
  }

  addAppointmentTimeButtonHandler() {
    // $scope.initializeDatePicker('addAppointmentTimeDateInput', (date) => {
    //   $scope.addAppointmentTimeInformation.selectedDate = date;
    //   $scope.$apply();
    // }, (date) => isDateInPast(date));
    this.addAppointmentTimeButtonClicked = true;
  }

  addAppointmentTimeCancelButtonHandler() {
    // this.addAppointmentTimeInformation = this.;
    // this.addAppointmentTimeButtonClicked = false;

  }

  addAppointmentTimeSaveButtonHandler() {
    if (this.savingAppointmentTime) {
      return;
    }
    this.savingAppointmentTime = true;

    
    const appointmentTimeInformation = this.addAppointmentTimeInformation;
    
    let siteId;
    let appointmentTypeId;
    if (siteId = this.siteInformation?.siteId) {
        if (appointmentTypeId = appointmentTimeInformation.appointmentType) {
        const date = appointmentTimeInformation.scheduledDateString;
        const scheduledTime = appointmentTimeInformation.scheduledTimeString;
        const numberOfAppointments = appointmentTimeInformation.numberOfAppointments;

        this.managementService.addAppointmentTime(siteId, date, scheduledTime, appointmentTypeId, numberOfAppointments, appointmentTimeInformation.is_hidden)
          .subscribe({
            next: (result) => {
            this.updateAppointmentTimesTable()
            this.addAppointmentTimeInformation = this.defaultAddAppointmentTimeInformation
            this.addAppointmentTimeButtonClicked = false;
            this.error = null

            this.savingAppointmentTime = false;
          }, 
          error: (error) => {
            console.log(error)
            this.error = error
            this.savingAppointmentTime = false;
          }})
      }
    }
  };

  updateAppointmentTimesTable() {
    let siteId;
    if (siteId = this.siteInformation?.siteId) {
      this.managementService.getAppointmentTimesForSite(siteId).subscribe((result) => {
        this.siteInformationAppointmentTimes = result;
        this.createAppointmentTimes();
      })
    }
  }

  createAppointmentTimes() {
    this.appointmentTimes = {}
    this.siteDescriptiveTimes = []
    for (const appointmentTime of this.siteInformationAppointmentTimes) {
      if (this.appointmentTimes[appointmentTime.scheduledDateString] == null) {
        this.appointmentTimes[appointmentTime.scheduledDateString] = new Array()
        this.siteDescriptiveTimes.push(appointmentTime.scheduledDateString)
      }
      this.appointmentTimes[appointmentTime.scheduledDateString].push(appointmentTime)
    }
  }

  selectSite(site: Site | null) {
    this.selectedSite = site
    this.siteInformation = null;
    
    let siteId;
    if (siteId = site?.siteId) {
      this.managementService.getSiteInformation(siteId).subscribe((result) => {
        this.siteInformation = result
        this.updateAppointmentTimesTable()
      } )
    }
    // SitesDataService.getSiteInformation(siteId).then((result) => {
    //   if (result == null || !result.success) {
    //     const errorMessage = result.error || 'There was an error loading site information. Please refresh and try again.';
    //     NotificationUtilities.giveNotice('Failure', errorMessage, false);
    //     return;
    //   }

    //   this.siteInformation = result.site;
    //   // $scope.createAppointmentTimesMap();
    // });
  }
}

interface AddAppointmentTimeInformation {
  scheduledDateString: string
  scheduledTimeString: string
  numberOfAppointments: number
  appointmentType: string
  // name: string
  is_hidden: boolean
}

interface Times {
  timeString: string
  time: number
}